export default{
    user : {},
    checkForLoggedInUser : false,
    studentSubjects : [],
    facultySubjects : [],
    studentAssignments : [],
    postedAssignments : [],
    schedule :[],
    upcomingAssignments : []
}